export default __webpack_public_path__ + "static/media/SyncError.683ff5c5.svg";